import { DEFAULT_ODDS_BY_COLUMN, SPORTSBOOK_COLUMNS } from "./table-styles";
import { oddsAreBetterForBettor, type DisplayPlayerProp } from "./utils-v2";

export const formatPercentage = (value: any) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return "\u2013";
  const rounded = Number(numeric.toFixed(1));
  return (rounded === 0 ? 0 : rounded).toFixed(1);
};

export const toFiniteOdds = (value: unknown): number | null => {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }
  if (typeof value === "string") {
    if (value.trim() === "") {
      return null;
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
};

export function getBaselineOddsForRow(
  row: DisplayPlayerProp,
  platformColumnKey: string,
): number | null {
  const raw = row[platformColumnKey as keyof DisplayPlayerProp];
  const parsed = toFiniteOdds(raw);
  if (parsed != null) {
    return parsed;
  }
  const fallback = DEFAULT_ODDS_BY_COLUMN[platformColumnKey];
  return typeof fallback === "number" ? fallback : null;
}

export function isAltBetterThanSelected(
  row: DisplayPlayerProp,
  columnKey: string,
  platformColumnKey: string,
  baselineOdds: number | null,
): boolean {
  if (columnKey === platformColumnKey) {
    return false;
  }
  if (!SPORTSBOOK_COLUMNS.has(columnKey)) {
    return false;
  }
  if (baselineOdds == null || baselineOdds === 0) {
    return false;
  }
  const candidate = toFiniteOdds(row[columnKey as keyof DisplayPlayerProp]);
  if (candidate == null || candidate === 0) {
    return false;
  }
  return oddsAreBetterForBettor(candidate, baselineOdds);
}
